import Titulo from '../../components/tipografia/Titulo';
import React, { ReactNode, useCallback, useEffect } from 'react';
import styles from './page.module.css';
import LayoutUsuario from '../../components/navegacao/LayoutUsuario';
import Descricao from '../../components/tipografia/Descricao';
import HBox from '../../components/layout/HBox';
import Botao from '../../components/Botao';
import VBox from '../../components/layout/VBox';
import CampoTexto from '../../components/Formulario/CampoTexto';
import Icon from '@/components/Icon';
import {
  mdiAlertCircle,
  mdiEmail,
  mdiLoading,
  mdiMagnify,
  mdiPen,
  mdiPlus,
  mdiTrashCan,
  mdiWrench,
} from '@mdi/js';
import DataTable, { DataTableHeader } from '../../components/layout/DataTable';
import { useInfiniteQuery, useMutation, useQuery } from 'react-query';
import axios from 'axios';
import { useDebounce } from '../chat/useDebounce';
import IconeCanal from '../../components/layout/IconeCanal';
import { nanoid } from 'nanoid';
import { CanalDto } from '@tera/shared/src/dto/CanalDto';
import Modal from '../../components/layout/Modal';
import FormCanal from '../../components/modelos/FormCanal';
import { toast } from 'react-toastify';
import BotaoSeletor from '../../components/BotaoSeletor';
import Grid, { GridItem } from '@/components/layout/Grid';
import { PopupCenter } from '@/lib/popup';
import { queryClient } from '@/queryClient';
import { sign } from 'crypto';
import Subtitulo from '@/components/tipografia/Subtitulo';
import CampoCheckbox from '@/components/Formulario/CampoCheckbox';
import { Link } from '@/components/layout/Link';
import FreeTierModal from '@/components/FreeTierModal';
import { GRAPH_API_VERSION } from '@tera/shared/src/lib/graphApi';
import { coexistenciaDisponivel } from '@/lib/whatsappSignup';
import { ComoFuncionaCoexistencia, LimitacoesCoexistencia } from '@/components/modelos/canal/AvisoCoexistencia';

type PageProps = {};

type ResponseList = {
  status: number;
  ok?: boolean;
  result: CanalDto[];
  total: number;
  cursor: string | number | null;
};

type ImpactoExclusao = {
  podeExcluir: boolean;
  chatsAtivos: number;
  chatsEmAtendimento: number;
  filasAguardando: number;
  avisos: string[];
};

const Page = ({ }: PageProps) => {
  const [editObject, setEditObject] = React.useState<CanalDto | null>(null);
  const [fieldErrors, setFieldErrors] = React.useState<Record<
    string,
    string
  > | null>(null);

  // Estado para modal de exclusão com impacto
  const [canalParaExcluir, setCanalParaExcluir] = React.useState<CanalDto | null>(null);
  const [impactoExclusao, setImpactoExclusao] = React.useState<ImpactoExclusao | null>(null);
  const [carregandoImpacto, setCarregandoImpacto] = React.useState(false);

  const [search, setSearch] = React.useState<string>('');
  const debouncedSearch = useDebounce(search, 500);

  // Buscar capacidades do plano
  const capacidadesQuery = useQuery(
    ['capacidades'],
    async () => {
      const res = await axios.get('/api/capacidades', {
        withCredentials: true,
      });
      return res.data;
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 30000, // 30 segundos
    }
  );

  const [showModalLogin360, setShowModalLogin360] =
    React.useState<boolean>(false);
  const [showModalNew360, setShowModalNew360] = React.useState<boolean>(false);
  const [showModalNewWhatsapp, setShowModalNewWhatsapp] = React.useState<boolean>(false);
  const [showModalNewWhatsappCoex, setShowModalNewWhatsappCoex] = React.useState<boolean>(false);

  const [showFreeTierModal, setShowFreeTierModal] = React.useState<boolean>(false);

  const openLoginD360Window = () => {
    const windowFeatures =
      'toolbar=no, menubar=no, width=600, height=900, top=100, left=100';
    const partnerId = import.meta.env.VITE_D360_PARTNER_ID;
    const redirectUrl = decodeURIComponent(window.location.origin + '/onboard');

    // Open the new window with the specified URL
    window.open(
      'https://hub.360dialog.com/dashboard/app/' +
      partnerId +
      '/permissions?next=login&redirect_url=' +
      redirectUrl,
      'integratedOnboardingWindow',
      windowFeatures,
    );
  };

  const openNewD360Window = () => {
    const windowFeatures =
      'toolbar=no, menubar=no, width=600, height=900, top=100, left=100';
    const partnerId = import.meta.env.VITE_D360_PARTNER_ID;
    const redirectUrl = decodeURIComponent(window.location.origin + '/onboard');

    // Open the new window with the specified URL
    window.open(
      'https://hub.360dialog.com/dashboard/app/' +
      partnerId +
      '/permissions?redirect_url=' +
      redirectUrl,
      'integratedOnboardingWindow',
      windowFeatures,
    );
  };

  const handleOAuthCode = async (code: string, signupData: any, coexistence = false) => {
    console.log('Código OAuth recebido:', code);
    console.log('Dados do signup:', signupData);

    // Extrair os dados necessários para o WhatsApp, independente da estrutura
    const phoneNumberId = signupData?.phone_number_id ||
      signupData?.signupData?.phone_number_id;
    const wabaId = signupData?.waba_id ||
      signupData?.signupData?.waba_id;
    const businessId = signupData?.business_id ||
      signupData?.signupData?.business_id;

    try {
      // Enviar o código para o backend
      const response = await axios.post('/api/canal/whatsapp/auth/code', {
        code,
        phone_number_id: phoneNumberId,
        waba_id: wabaId,
        business_id: businessId,
        coexistence,
      });

      // Se tivermos sucesso, invalidar as queries para atualizar a lista
      await queryClient.invalidateQueries(['canal']);

      toast('WhatsApp Business conectado com sucesso!', {
        toastId: 'whatsapp-success',
        position: 'top-center',
        type: 'success',
        autoClose: 5000,
      });

      return response.data;
    } catch (error: any) {
      console.error('Erro ao processar código de autenticação:', error);

      toast(error.response?.data?.msg || 'Erro ao conectar WhatsApp', {
        toastId: 'whatsapp-error',
        position: 'top-center',
        type: 'error',
        autoClose: 5000,
      });

      throw error;
    }
  };

  const signupData = React.useRef<any>(null);
  useEffect(() => {
    //@ts-ignore
    window.fbAsyncInit = function () {
      //@ts-ignore
      FB.init({
        appId: '1089871969306715',
        autoLogAppEvents: true,
        xfbml: true,
        version: GRAPH_API_VERSION
      });
    };

    // Listener para mensagens do Facebook - captura os dados do Embedded Signup
    const handleFacebookMessage = (event: MessageEvent) => {
      if (!event.origin.endsWith('facebook.com')) return;

      console.log('Recebida mensagem do Facebook:', event.origin, typeof event.data);

      try {
        // Precisamos fazer parse da string para JSON se ainda não for um objeto
        let data;
        if (typeof event.data === 'string') {
          data = JSON.parse(event.data);
        } else {
          data = event.data;
        }

        console.log('Dados parseados do Facebook:', data);

        // Limpamos qualquer dado de signup anterior
        if (data.type === 'WA_EMBEDDED_SIGNUP') {
          // Se o usuário concluiu o fluxo de signup
          if (data.event === 'FINISH') {
            console.log('Signup concluído com sucesso:', data.data);

            // Armazenamos os dados para uso posterior e atualizamos o state
            const signupInfo = {
              phone_number_id: data.data.phone_number_id,
              waba_id: data.data.waba_id,
              business_id: data.data.business_id
            };

            signupData.current = signupInfo;

            // Exibimos um toast para o usuário
            toast('Configuração do WhatsApp concluída. Finalizando registro...', {
              toastId: 'signup-success',
              position: 'top-center',
              type: 'success'
            });

            // Se o usuário cancelou o fluxo de signup
          } else if (data.event === 'CANCEL') {
            const { current_step } = data.data;
            console.warn("Signup cancelado no passo:", current_step);

            signupData.current = null;

            toast('Configuração do WhatsApp cancelada', {
              toastId: 'signup-cancel',
              position: 'top-center',
              type: 'warning',
              autoClose: 0
            });

            // Se ocorreu um erro durante o fluxo de signup
          } else if (data.event === 'ERROR') {
            const { error_message } = data.data;
            console.error("Erro durante signup:", error_message);

            signupData.current = null;

            toast(`Erro na configuração do WhatsApp: ${error_message}`, {
              toastId: 'signup-error',
              position: 'top-center',
              type: 'error'
            });
          }
        }
      } catch (error) {
        console.log('Erro ao processar mensagem do Facebook:', error, event.data);
      }
    };

    window.addEventListener('message', handleFacebookMessage);

    return () => {
      window.removeEventListener('message', handleFacebookMessage);
    };
  }, []);

  // O callback do Facebook não é mais usado diretamente
  // A comunicação agora é feita via postMessage do popup intermediário

  const openNewWhatsappWindow = async (coexistence = false) => {
    // Gerar token CSRF para validar a comunicação
    const csrfToken = await generateCSRFToken();

    const host = (import.meta.env.VITE_PUBLIC_HOST || 'https://tera.terachat.com.br')

    console.log('Token CSRF gerado:', csrfToken);    // URL da página intermediária que vai abrir o popup do Facebook com o token CSRF
    const currentOrigin = window.location.origin;
    // `mode=coex` faz o popup usar a configuração de Embedded Signup de
    // coexistência (número já em uso no app WhatsApp Business).
    const modeParam = coexistence ? '&mode=coex' : '';
    const popupURL = `${host}/login/auth-fb?csrf=${encodeURIComponent(csrfToken)}&origin=${encodeURIComponent(currentOrigin)}${modeParam}`;
    // O popup roda no host central (tera.terachat.com.br) mesmo quando o tenant está em outro domínio
    const popupOrigin = new URL(popupURL).origin;
    const popupWindow = PopupCenter(popupURL, 'FacebookAuthPopup', 600, 600);

    if (!popupWindow) {
      toast('Não foi possível abrir a janela de autenticação. Verifique se os popups estão permitidos.', {
        type: 'error',
        position: 'top-center',
        autoClose: 8000
      });

      // Mostrar um modal com instruções para desativar o bloqueador de popup
      toast.info(
        <div>
          <p><strong>Como desbloquear popups:</strong></p>
          <p>1. Procure pelo ícone de bloqueio de popup na barra de endereço do navegador</p>
          <p>2. Clique e selecione "Sempre permitir popups de [este site]"</p>
          <p>3. Clique em "Tentar Novamente" para autenticar</p>
        </div>,
        { autoClose: false }
      );

      return;
    }

    // Verificar se o popup foi realmente aberto e não foi bloqueado silenciosamente
    // (só `closed` é acessível cross-origin; ler outerHeight lança SecurityError)
    setTimeout(() => {
      if (popupWindow && popupWindow.closed) {
        toast('O popup foi bloqueado pelo navegador. Habilite popups para continuar.', {
          type: 'warning',
          position: 'top-center',
          autoClose: 8000
        });
      }
    }, 1000);

    // Prazo máximo para autenticação (15 minutos)
    const authTimeout = setTimeout(() => {
      if (popupWindow && !popupWindow.closed) {
        popupWindow.close();
        window.removeEventListener('message', messageHandler);
        toast('Tempo limite de autenticação excedido. Tente novamente.', {
          type: 'warning',
          position: 'top-center',
          autoClose: 5000
        });
      }
    }, 15 * 60_000);

    // Configurar o listener para receber mensagens do popup
    const messageHandler = (event: MessageEvent) => {
      try {
        // Verificação rigorosa da origem: aceitar mensagens do host do popup
        // (a autenticidade é garantida pelo token CSRF validado abaixo)
        if (event.origin !== popupOrigin && event.origin !== window.location.origin) {
          console.warn('Origem da mensagem não corresponde à origem do popup', event.origin, popupOrigin);
          return;
        }

        // Verificar se a mensagem contém dados do Facebook e tem o tipo correto
        if (event.data?.type === "facebook_auth") {
          // Validar o token CSRF para prevenir ataques
          console.log('Validação CSRF - Token Esperado:', csrfToken);
          console.log('Validação CSRF - Token Recebido:', event.data.csrfToken);

          if (event.data.csrfToken !== csrfToken) {
            console.error("Token CSRF inválido", event.data.csrfToken, csrfToken);
            toast('Erro de segurança: Token de validação inválido', {
              type: 'error',
              position: 'top-center',
              autoClose: 5000
            });
            return;
          }

          console.log("Dados de autenticação do Facebook recebidos");

          // Remover o listener quando não for mais necessário
          window.removeEventListener('message', messageHandler);
          clearTimeout(authTimeout);

          // Processar os dados da autenticação
          console.log('Dados completos recebidos do popup:', event.data);

          if (event.data.code) {
            // Validar que o código parece ser um código de autenticação válido
            if (typeof event.data.code === 'string' && event.data.code.length > 10) {
              console.log('Código válido recebido, processando...');

              toast('Aguarde enquanto processamos os dados de login...', {
                type: 'info',
                position: 'top-center',
                autoClose: 5000
              });

              // O modo vem do popup, não do botão clicado: só ele vê o evento
              // de conclusão da Meta, que é quem diz se o número veio do app
              // WhatsApp Business. O fluxo padrão pode terminar em
              // coexistência, e nesse caso pular o /register é obrigatório.
              handleOAuthCode(event.data.code, event.data.signupData, !!event.data.coexistence);
            } else {
              console.warn('Código inválido recebido:', event.data.code);
              toast('Erro: Código de autenticação inválido', {
                type: 'error',
                position: 'top-center',
                autoClose: 5000
              });
            }
          } else if (event.data.error) {
            toast(`Erro na autenticação do Facebook: ${event.data.error}`, {
              type: 'error',
              position: 'top-center',
              autoClose: 5000
            });
          }

          // Fechar o popup após receber os dados
          if (popupWindow && !popupWindow.closed) {
            popupWindow.close();
          }
        }
      } catch (error) {
        console.error("Erro ao processar mensagem de autenticação:", error);
        toast('Erro ao processar autenticação', {
          type: 'error',
          position: 'top-center',
          autoClose: 5000
        });
      }
    };

    // Adicionar o listener
    window.addEventListener('message', messageHandler);

    // Armazenar o token CSRF de forma temporária e segura
    // @ts-ignore
    window.csrfToken = csrfToken;

    // Se o popup for fechado sem completar a autenticação, remover o listener
    const checkPopupClosed = setInterval(() => {
      if (popupWindow && popupWindow.closed) {
        clearInterval(checkPopupClosed);
        window.removeEventListener('message', messageHandler);
        // Limpar token CSRF
        // @ts-ignore
        window.csrfToken = null;
        console.log('Popup do Facebook foi fechado sem completar a autenticação');
      }
    }, 1000);
  };

  // Função para gerar um token CSRF seguro
  const generateCSRFToken = async (): Promise<string> => {
    try {
      // Usar nanoid para gerar um token seguro
      const token = nanoid(32);
      // @ts-ignore
      window.csrfToken = token;
      return token;
    } catch (error) {
      console.error("Erro ao gerar token CSRF:", error);
      // Fallback para método alternativo se nanoid falhar
      const randomValues = new Uint32Array(4);
      window.crypto.getRandomValues(randomValues);
      return Array.from(randomValues).map(val => val.toString(16)).join('');
    }
  };

  const openInstagramWindow = () => {
    const redirectUrl = decodeURIComponent((import.meta.env.VITE_PUBLIC_HOST || 'https://tera.terachat.com.br') + '/canal/instagram/auth/callback');
    // scope=instagram_business_basic%2Cinstagram_business_manage_messages%2Cinstagram_business_manage_comments%2Cinstagram_business_content_publish%2Cinstagram_business_manage_insights
    console.log('redirectUrl', redirectUrl);
    console.log('window.location.origin', window.location.origin);
    const url = `https://www.instagram.com/oauth/authorize?enable_fb_login=0&force_authentication=1&client_id=1410865780362783&redirect_uri=${redirectUrl}&response_type=code&scope=instagram_business_basic%2Cinstagram_business_manage_messages`

    const authWindow = PopupCenter(url, 'Instagram', 600, 600);
    const handler = async (event: any) => {
      if (event.origin !== window.location.origin) {
        console.warn('different origin', event.origin, window.location.origin)
      }

      if (event.data?.type === "oauth_code") {
        console.log("Código OAuth recebido:", event.data.code);

        const res = await axios.post(`/api/webhooks/instagram/token`, { code: event.data.code, type: 'igrm' });
        // queryClient.invalidateQueries('agenda/calendarios');

        // setValueIntegracao((prev: any) => ({ ...prev, integracao_token_presente: true, integracao_agenda_id: res.data.integracao_agenda_id }));

        window.removeEventListener("message", handler);

        // setAutenticandoOauth2(false);
        // queryClient.invalidateQueries(['agenda'])
      }
      return true
    }
    const unloadHandler = () => {
      // setAutenticandoOauth2(false);
      return true
    }
    window.addEventListener("message", handler);
    authWindow!.addEventListener("unload", unloadHandler)
  };

  const [whVerifying, setWhVerifying] = React.useState<number | null>(null);

  const whVerifyMutator = useMutation(
    async (id: number) => {
      setWhVerifying(id);
      return await axios.post(
        `/api/canal/${id}/wh-fix`,
        {},
        {
          withCredentials: true,
        },
      );
    },
    {
      onSettled: () => {
        setWhVerifying(null);
        queryList.refetch();
      },
    },
  );

  const envioVerificarMutator = useMutation(
    async (id: number) => {
      const res = await axios.post(
        `/api/canal/${id}/envio/verificar`,
        {},
        {
          withCredentials: true,
        },
      );
      return res.data as { ok: boolean; msg?: string };
    },
    {
      onSuccess: (data) => {
        toast(data.ok ? 'Acesso ao número confirmado. O erro foi dado como resolvido.' : `O problema continua: ${data.msg}`, {
          position: 'top-center',
          type: data.ok ? 'success' : 'warning',
          autoClose: 8000,
        });
      },
      onError: () => {
        toast('Ocorreu um erro ao verificar o canal.', {
          position: 'top-center',
          type: 'warning',
          autoClose: 5000,
        });
      },
      onSettled: () => {
        queryList.refetch();
      },
    },
  );

  const receberEmailsMutator = useMutation(
    async (id: number) => {
      return axios.post(
        `/api/canal/${id}/receber-emails`,
        {},
        {
          withCredentials: true,
        },
      );
    },
    {
      onSuccess: () => {
        toast('Rotina executada com sucesso', {
          toastId: 'success',
          position: 'top-center',
          type: 'success',
          autoClose: 5000,
        });
      },
      onError: (err: any) => {
        console.error(err);

        toast('Ocorreu um erro ao tentar verificar os e-mails.', {
          toastId: 'error',
          position: 'top-center',
          type: 'warning',
          autoClose: 5000,
        });
      },
      onSettled: () => {
        queryList.refetch();
      },
    },
  );

  const handleWhVerify = (id: number) => {
    whVerifyMutator.mutate(id);
  };

  const headers: DataTableHeader[] = [
    {
      label: 'Tipo',
      width: '32px',
      render: (row: any) => {
        return <IconeCanal tipo={row.tipo} style={{ height: '24px' }} />;
      },
    },
    { label: 'Nome', width: '50%', column: 'nome' },
    {
      label: '',
      width: '50%',
      alignRight: true,
      render(row) {
        // Aviso de falhas IMAP para canais de email
        if (row.tipo === 'email' && row.propriedades?.imap_falhas_consecutivas >= 5) {
          return (
            <span
              style={{
                color: 'var(--tc-color-danger)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: '4px',
              }}
            >
              <Icon path={mdiAlertCircle} size={0.7} color="var(--tc-color-danger)" />
              Conexão IMAP com erro — verifique a configuração
            </span>
          );
        }

        // Erro de envio que derruba o canal (pagamento, token, conta bloqueada)
        if (row.tipo === 'whatsapp' && row.propriedades?.envio_erro) {
          const verificando = envioVerificarMutator.isLoading && envioVerificarMutator.variables === row.id;
          return (
            <span
              style={{
                color: 'var(--tc-color-danger)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: '4px',
              }}
              title={row.propriedades.envio_erro_data ? `Desde ${new Date(row.propriedades.envio_erro_data).toLocaleString()}` : undefined}
            >
              <Icon path={mdiAlertCircle} size={0.7} color="var(--tc-color-danger)" />
              {row.propriedades.envio_erro}
              {verificando ? (
                <Icon path={mdiLoading} size={0.8} color="var(--tc-color-gray-700)" spin />
              ) : (
                <Botao
                  variant="outline-primary"
                  size="small"
                  icon={mdiWrench}
                  onClick={() => envioVerificarMutator.mutate(row.id)}
                >
                  Verificar
                </Botao>
              )}
            </span>
          );
        }

        const webhookCheck = row.webhookCheck;
        if (!webhookCheck.result) {
          return (
            <span
              style={{
                color: 'var(--tc-color-warning)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              {webhookCheck.msg}
              {(!webhookCheck.msg ||
                webhookCheck.msg.indexOf('não suportado') === -1) && (
                  <>
                    {whVerifying === row.id && !queryList.isFetching ? (
                      <span>
                        <Icon
                          path={mdiLoading}
                          size={0.8}
                          color="var(--tc-color-gray-700)"
                          spin
                        />
                        Verificando...
                      </span>
                    ) : null}
                    {whVerifying !== row.id ? (
                      <Botao
                        variant="outline-primary"
                        size="small"
                        icon={mdiWrench}
                        onClick={() => handleWhVerify(row.id)}
                      >
                        Verificar
                      </Botao>
                    ) : null}
                  </>
                )}
            </span>
          );
        }
        return null;
      },
    },
    {
      label: 'Ações',
      width: '100px',
      stickRight: true,
      alignRight: true,
      render: (row: any) => {
        return (
          <HBox gap="8px" style={{ justifyContent: 'flex-end' }}>
            {row.tipo === 'email' && !receberEmailsMutator.isLoading && (
              <Botao
                variant="none-info"
                icon={mdiEmail}
                title="Verificar e-mails"
                onClick={() => receberEmailsMutator.mutateAsync(row.id)}
              ></Botao>
            )}
            {row.tipo === 'email' && receberEmailsMutator.isLoading && (
              <Icon
                path={mdiLoading}
                size={0.8}
                color="var(--tc-color-gray-700)"
                spin
              />
            )}
            <Botao
              variant="none-primary"
              icon={mdiPen}
              title="Editar"
              onClick={() => setEditObject(row as CanalDto)}
            ></Botao>
            <Botao
              variant="none-danger"
              icon={mdiTrashCan}
              title="Apagar"
              onClick={() => handleAbrirModalExclusao(row as CanalDto)}
            />
          </HBox>
        );
      },
    },
  ];

  const queryList = useInfiniteQuery({
    queryKey: ['canal', debouncedSearch],
    queryFn: async ({ pageParam }) => {
      const params = new URLSearchParams({
        txt: debouncedSearch,
        c: pageParam,
      });

      return await axios.get<ResponseList>(`/api/canal?${params.toString()}`, {
        withCredentials: true,
      });
    },
    getNextPageParam: lastPage => lastPage.data.cursor ?? undefined,
  });

  const canalChangeMutator = useMutation(
    async () => {
      if (!editObject) return;

      setFieldErrors(null);
      if (editObject.id) {
        return await axios.put(`/api/canal/${editObject.id}`, editObject, {
          withCredentials: true,
        });
      } else {
        return await axios.post(`/api/canal`, editObject, {
          withCredentials: true,
        });
      }
    },
    {
      onSuccess: () => {
        setFieldErrors(null);
        queryList.refetch();
        capacidadesQuery.refetch();
        setEditObject(null);
      },
      onError: (err: any) => {
        if (err.response?.status === 422) {
          setFieldErrors(err.response?.data?.fieldErrors ?? {});
        }

        const errorMsg = err.response?.data?.msg ?? 'Erro desconhecido';
        const toastType = err.response?.status === 403 ? 'error' : 'warning';

        toast(errorMsg, {
          toastId: 'error',
          position: 'top-center',
          type: toastType,
          autoClose: err.response?.status === 403 ? 8000 : 5000,
        });
      },
    },
  );

  const canalDeleteMutator = useMutation(
    async (id: number) => {
      return await axios.delete(`/api/canal/${id}`, {
        withCredentials: true,
      });
    },
    {
      onSuccess: () => {
        toast('Canal apagado com sucesso', {
          toastId: 'success',
          position: 'top-center',
          type: 'success',
          autoClose: 5000,
        });
        queryList.refetch();
        capacidadesQuery.refetch();
      },
      onError: (err: any) => {
        console.error(err);
        toast('Ocorreu um erro ao tentar apagar o canal.', {
          toastId: 'error',
          position: 'top-center',
          type: 'warning',
          autoClose: 5000,
        });
      },
      onSettled: () => {
        queryList.refetch();
      },
    },
  );

  const handleCanalChange = useCallback(async () => {
    await canalChangeMutator.mutate();
  }, [canalChangeMutator]);

  // Função para abrir o modal de exclusão e buscar impacto
  const handleAbrirModalExclusao = async (canal: CanalDto) => {
    setCanalParaExcluir(canal);
    setImpactoExclusao(null);
    setCarregandoImpacto(true);

    try {
      const res = await axios.get<ImpactoExclusao & { ok: boolean }>(
        `/api/canal/${canal.id}/verificar-exclusao`,
        { withCredentials: true }
      );
      setImpactoExclusao(res.data);
    } catch (err) {
      console.error('Erro ao verificar impacto da exclusão:', err);
      // Mesmo com erro, permite excluir (fallback)
      setImpactoExclusao({
        podeExcluir: true,
        chatsAtivos: 0,
        chatsEmAtendimento: 0,
        filasAguardando: 0,
        avisos: [],
      });
    } finally {
      setCarregandoImpacto(false);
    }
  };

  const handleConfirmarExclusao = () => {
    if (canalParaExcluir?.id) {
      canalDeleteMutator.mutate(canalParaExcluir.id);
      setCanalParaExcluir(null);
      setImpactoExclusao(null);
    }
  };

  const handleCancelarExclusao = () => {
    setCanalParaExcluir(null);
    setImpactoExclusao(null);
  };

  const handleCanalDelete = (id: number) => {
    canalDeleteMutator.mutate(id);
  };

  const queryFlatList =
    queryList.data?.pages?.map(p => p.data.result)?.flat() ?? [];
  const total =
    queryList.data?.pages?.[queryList.data.pages.length - 1]?.data?.total ?? 0;

  const editMode = !!editObject?.id && editObject.id > 0;

  const handleCloseModal = () => {
    setEditObject(null);
    setFieldErrors(null);
  };

  const handleConfirmLogin360 = () => {
    setShowModalLogin360(false);
    openLoginD360Window();
  };

  const handleConfirmNew360 = () => {
    setShowModalNew360(false);
    openNewD360Window();
  };

  const handleConfirmNewWhatsapp = () => {
    setShowModalNewWhatsapp(false);
    openNewWhatsappWindow();
  };

  const handleConfirmNewWhatsappCoex = () => {
    setShowModalNewWhatsappCoex(false);
    openNewWhatsappWindow(true);
  };

  const host = `${window.location.protocol}//${window.location.host}`;

  const [checklist, setChecklist] = React.useState({
    noWhatsappAccount: false,
    hasFacebookBusiness: false,
    acceptTerms: false,
    acceptPrivacyPolicy: false,
    acceptCommercialPolicies: false,
  });

  const isChecklistValid = Object.values(checklist).every(value => value);

  // Checklist da coexistência: os requisitos são outros — aqui o número
  // *precisa* estar em uso no app WhatsApp Business, e o cliente precisa saber
  // o que a Meta desativa no aparelho ao conectar.
  const [checklistCoex, setChecklistCoex] = React.useState({
    hasBusinessApp: false,
    appVersion: false,
    cienteLimitacoes: false,
    hasFacebookBusiness: false,
    acceptTerms: false,
    acceptPrivacyPolicy: false,
    acceptCommercialPolicies: false,
  });

  const isChecklistCoexValid = Object.values(checklistCoex).every(value => value);

  const [showModalWhatsappAccountFaq, setShowModalWhatsappAccountFaq] = React.useState(false);
  const [showModalCreateFBusiness, setShowModalCreateFBusiness] = React.useState(false);

  return (
    <LayoutUsuario>
      <FreeTierModal
        show={showFreeTierModal}
        onClose={() => setShowFreeTierModal(false)}
        feature="todas as funcionalidades, como múltiplos canais e bots ativos"
      />

      {/* Modal de confirmação de exclusão com impacto */}
      <Modal
        title="Excluir Canal"
        show={!!canalParaExcluir}
        onClose={handleCancelarExclusao}
        onCancel={handleCancelarExclusao}
        onConfirm={handleConfirmarExclusao}
        confirmProps={{
          variant: 'danger',
          label: 'Excluir Canal',
          disabled: carregandoImpacto || canalDeleteMutator.isLoading,
        }}
        cancelProps={{
          disabled: canalDeleteMutator.isLoading,
        }}
      >
        <VBox gap="16px" style={{ padding: '8px 0' }}>
          {carregandoImpacto ? (
            <HBox gap="8px" style={{ alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
              <Icon path={mdiLoading} size={1} spin color="var(--tc-color-primary)" />
              <span>Verificando impacto da exclusão...</span>
            </HBox>
          ) : (
            <>
              <Descricao>
                Você está prestes a excluir o canal <strong>{canalParaExcluir?.nome}</strong>.
              </Descricao>

              <div>
                <Descricao>Esta ação irá:</Descricao>
                <ul style={{ marginLeft: '1.5rem', marginTop: '0.5rem' }}>
                  <li>Remover o canal permanentemente</li>
                  <li>Desativar os bots associados</li>
                  {canalParaExcluir?.tipo === 'whatsapp' && (
                    <li>Desassociar o número WhatsApp do Terachat (não remove sua conta no Facebook Business)</li>
                  )}
                </ul>
              </div>

              {/* Avisos de impacto em chats/filas */}
              {impactoExclusao && impactoExclusao.avisos.length > 0 && (
                <div style={{
                  backgroundColor: 'var(--tc-color-warning-bg, #fff3cd)',
                  border: '1px solid var(--tc-color-warning, #ffc107)',
                  borderRadius: '8px',
                  padding: '12px 16px',
                }}>
                  <HBox gap="8px" style={{ alignItems: 'flex-start' }}>
                    <Icon path={mdiAlertCircle} size={1} color="var(--tc-color-warning, #ffc107)" />
                    <VBox gap="4px">
                      <strong style={{ color: 'var(--tc-color-warning-text, #856404)' }}>
                        Atenção: Existem conversas ativas
                      </strong>
                      <ul style={{ margin: 0, paddingLeft: '1.2rem', color: 'var(--tc-color-warning-text, #856404)' }}>
                        {impactoExclusao.avisos.map((aviso, idx) => (
                          <li key={idx}>{aviso}</li>
                        ))}
                      </ul>
                      <Descricao style={{ marginTop: '8px', fontSize: '0.9em', color: 'var(--tc-color-warning-text, #856404)' }}>
                        Essas conversas serão <strong>finalizadas automaticamente</strong> ao excluir o canal.
                      </Descricao>
                    </VBox>
                  </HBox>
                </div>
              )}

              <Descricao style={{ fontWeight: 500 }}>
                Tem certeza que deseja continuar?
              </Descricao>
            </>
          )}
        </VBox>
      </Modal>

      <Modal
        size="lg"
        title="Novo cadastro - 360Dialog"
        show={showModalNew360}
        onClose={() => setShowModalNew360(false)}
        onCancel={() => setShowModalNew360(false)}
        onConfirm={handleConfirmNew360}
        confirmProps={{ label: 'Entendi. Continuar!' }}
      >
        <div style={{ padding: '16px' }}>
          <VBox gap="16px">
            <Descricao>
              Ao continuar, uma nova janela será aberta para realizar o
              onboarding de seus números de WhatsApp.
            </Descricao>
            <Descricao>
              1. Crie uma conta na 360Dialog. Guarde seu novo usuário e senha,
              pois podem ser utilizados depois para gerenciar os números.
            </Descricao>
            <Descricao>
              2. Siga os passos para autorizar seu WhatsApp Business API.
            </Descricao>
            <Descricao>
              3. Após autorizar, <b>não feche o popup!</b> Nossos sistemas irão
              validar e criar os registros necessários.
            </Descricao>
            <Descricao>
              4. Pronto! Seus números estarão ativos para uso!
            </Descricao>
          </VBox>
        </div>
      </Modal>

      <Modal
        size="lg"
        title="Login 360Dialog"
        show={showModalLogin360}
        onClose={() => setShowModalLogin360(false)}
        onCancel={() => setShowModalLogin360(false)}
        onConfirm={handleConfirmLogin360}
        confirmProps={{ label: 'Entendi. Continuar!' }}
      >
        <div style={{ padding: '16px' }}>
          <VBox gap="16px">
            <Descricao>
              Ao continuar, uma nova janela será aberta para configurar seus
              números de WhatsApp.
            </Descricao>
            <Descricao>1. Entre com seu login da 360Dialog.</Descricao>
            <Descricao>
              2. verifique se todos os números que deseja autorizar estão na
              lista. Se estiverem, clique em &quot;Authorize&quot;. Se não,
              marque os números desejados na combobox.
            </Descricao>
            <Descricao>
              3. Após autorizar, <b>não feche o popup!</b> Nossos sistemas irão
              validar e criar os registros necessários.
            </Descricao>
            <Descricao>
              4. Pronto! Seus números estarão ativos para uso!
            </Descricao>
          </VBox>
        </div>
      </Modal>

      <Modal
        size="lg"
        title="Login Facebook - WhatsApp"
        show={showModalNewWhatsapp}
        onClose={() => setShowModalNewWhatsapp(false)}
        onCancel={() => setShowModalNewWhatsapp(false)}
        onConfirm={handleConfirmNewWhatsapp}
        confirmProps={{
          disabled: !isChecklistValid,
          label: 'Continuar!',
          title: !isChecklistValid ? 'Preencha todos os campos do checklist' : undefined,
        }}
      >
        <div style={{ marginLeft: '1rem', padding: '16px', gap: '.5rem', display: 'grid' }}>
          <VBox style={{ border: '1px solid var(--tc-color-gray-300)', padding: '24px', gap: '.5rem', borderRadius: '24px' }}>
            <Subtitulo>O número já está em uso no app WhatsApp Business?</Subtitulo>
            <Descricao>
              Na tela da Meta, em vez de cadastrar um número novo, você pode escolher
              conectar a conta que já existe. O número entra em <b>modo de
                coexistência</b>: continua funcionando normalmente no celular e passa a
              funcionar também aqui no TeraChat.
            </Descricao>
            <ComoFuncionaCoexistencia />
            <Descricao><b>O que muda no seu aparelho</b></Descricao>
            <LimitacoesCoexistencia />
          </VBox>

          <VBox style={{ border: '1px solid var(--tc-color-gray-300)', padding: '24px', gap: '.5rem', borderRadius: '24px' }}>
            <Subtitulo>Checklist</Subtitulo>
            <CampoCheckbox
              name='noWhatsappAccount'
              size='large'
              value={checklist.noWhatsappAccount}
              onChange={(value) => setChecklist({ ...checklist, noWhatsappAccount: value })}
            >
              O número não está vinculado a nenhuma conta do WhatsApp — ou está no app
              WhatsApp Business e li o aviso de coexistência acima
            </CampoCheckbox>

            <div style={{ fontSize: '0.8rem' }}>
              <Botao variant="none-primary" onClick={() => setShowModalWhatsappAccountFaq(true)}>
                <span style={{ fontSize: '0.8rem' }}>
                  O número já está vinculado a uma conta do WhatsApp <b>pessoal</b>. O que fazer?
                </span>
              </Botao>
            </div>
            <CampoCheckbox
              name='hasFacebookBusiness'
              size='large'
              value={checklist.hasFacebookBusiness}
              onChange={(value) => setChecklist({ ...checklist, hasFacebookBusiness: value })}
            >
              Possuo uma conta no Facebook Business, ou sou o administrador de uma conta existente
            </CampoCheckbox>
            <div style={{ fontSize: '0.8rem', color: 'var(--tc-color-gray-500)' }}>
              <Botao variant="none-primary" onClick={() => setShowModalCreateFBusiness(true)}>
                <span style={{ fontSize: '0.8rem' }}>
                  Não tenho uma conta no Facebook Business. O que fazer?
                </span>
              </Botao>

            </div>

            <CampoCheckbox
              name='acceptTerms'
              size='large'
              value={checklist.acceptTerms}
              onChange={(value) => setChecklist({ ...checklist, acceptTerms: value })}
            >
              Li e aceito os Termos de Serviço do WhatsApp Business
            </CampoCheckbox>
            <div style={{ fontSize: '0.8rem', color: 'var(--tc-color-gray-500)' }}>
              Leia os Termos de Serviço aqui: <Link href="https://www.whatsapp.com/legal/business-terms" target="_blank">https://www.whatsapp.com/legal/business-terms</Link>
            </div>

            <CampoCheckbox
              name='acceptPrivacyPolicy'
              size='large'
              value={checklist.acceptPrivacyPolicy}
              onChange={(value) => setChecklist({ ...checklist, acceptPrivacyPolicy: value })}
            >
              Li e aceito a Política de Privacidade do WhatsApp Business
            </CampoCheckbox>
            <div style={{ fontSize: '0.8rem', color: 'var(--tc-color-gray-500)' }}>
              Leia a Política de Privacidade aqui: <Link href="https://www.whatsapp.com/legal/privacy-policy" target="_blank">https://www.whatsapp.com/legal/privacy-policy</Link>
            </div>

            <CampoCheckbox
              name='acceptCommercialPolicies'
              size='large'
              value={checklist.acceptCommercialPolicies}
              onChange={(value) => setChecklist({ ...checklist, acceptCommercialPolicies: value })}
            >
              Declaro que minha empresa está de acordo com as Políticas Comerciais do WhatsApp Business, e que não está nas organizações proibidas ou com restrições de uso
            </CampoCheckbox>
            <div style={{ fontSize: '0.8rem', color: 'var(--tc-color-gray-500)' }}>
              Leia as Políticas Comerciais aqui: <Link href="https://business.whatsapp.com/policy" target="_blank">https://business.whatsapp.com/policy</Link>
            </div>
          </VBox>

          <VBox style={{ border: '1px solid var(--tc-color-gray-300)', padding: '24px', gap: '.5rem', borderRadius: '24px' }}>
            <Subtitulo>Ao continuar...</Subtitulo>
            <Descricao>
              ...uma nova janela será aberta para configurar seus números de WhatsApp.
            </Descricao>
            <ol style={{ gap: '.5rem', display: 'grid' }}>
              <li>
                <Descricao>Entre com seus dados de empresa do Facebook e siga com o fluxo de cadastro.</Descricao>
              </li>
              <li>
                <Descricao>
                  Antes de concluir a integração, <b>cadastre uma forma de pagamento</b> para
                  o uso da API da Meta. Sem o cadastro, alguns serviços não estarão disponíveis.
                  Se precisar cadastrar depois, siga os seguintes passos:
                  <ol type='a' style={{ marginLeft: '2rem', gap: '.5rem' }}>
                    <li>Acesse o painel do Gerenciador do WhatsApp &gt; Visão geral em <Link href="https://business.facebook.com/wa/manage/home/" target="_blank">https://business.facebook.com/wa/manage/home/</Link></li>
                    <li>Clique no botão Adicionar forma de pagamento</li>
                    <li>Conclua o fluxo</li>
                  </ol>
                  (Mais informações na{' '}
                  <Link
                    href="https://www.facebook.com/business/help/488291839463771"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Central de Ajuda do Facebook
                  </Link>)
                </Descricao>
              </li>
              <li>
                <Descricao>
                  Pronto! Seus números estarão ativos para uso!
                </Descricao>
              </li>
            </ol>
          </VBox>
        </div>
      </Modal>

      <Modal
        size="lg"
        title="Conectar número já usado no WhatsApp Business"
        show={showModalNewWhatsappCoex}
        onClose={() => setShowModalNewWhatsappCoex(false)}
        onCancel={() => setShowModalNewWhatsappCoex(false)}
        onConfirm={handleConfirmNewWhatsappCoex}
        confirmProps={{
          disabled: !isChecklistCoexValid,
          label: 'Continuar!',
          title: !isChecklistCoexValid ? 'Preencha todos os campos do checklist' : undefined,
        }}
      >
        <div style={{ marginLeft: '1rem', padding: '16px', gap: '.5rem', display: 'grid' }}>
          <VBox style={{ border: '1px solid var(--tc-color-gray-300)', padding: '24px', gap: '.5rem', borderRadius: '24px' }}>
            <Subtitulo>Como funciona</Subtitulo>
            <Descricao>
              No modo de coexistência você continua usando o número normalmente no
              celular, e ao mesmo tempo ele passa a funcionar aqui no TeraChat.
            </Descricao>
            <ComoFuncionaCoexistencia />
          </VBox>

          <VBox style={{ border: '1px solid var(--tc-color-gray-300)', padding: '24px', gap: '.5rem', borderRadius: '24px' }}>
            <Subtitulo>Checklist</Subtitulo>
            <CampoCheckbox
              name='hasBusinessApp'
              size='large'
              value={checklistCoex.hasBusinessApp}
              onChange={(value) => setChecklistCoex({ ...checklistCoex, hasBusinessApp: value })}
            >
              O número já está em uso no aplicativo WhatsApp Business, e eu tenho acesso ao aparelho
            </CampoCheckbox>

            <CampoCheckbox
              name='appVersion'
              size='large'
              value={checklistCoex.appVersion}
              onChange={(value) => setChecklistCoex({ ...checklistCoex, appVersion: value })}
            >
              O aplicativo WhatsApp Business está atualizado (versão 2.24.17 ou superior)
            </CampoCheckbox>

            <CampoCheckbox
              name='cienteLimitacoes'
              size='large'
              value={checklistCoex.cienteLimitacoes}
              onChange={(value) => setChecklistCoex({ ...checklistCoex, cienteLimitacoes: value })}
            >
              Estou ciente das limitações do modo de coexistência
            </CampoCheckbox>
            <LimitacoesCoexistencia />

            <CampoCheckbox
              name='hasFacebookBusinessCoex'
              size='large'
              value={checklistCoex.hasFacebookBusiness}
              onChange={(value) => setChecklistCoex({ ...checklistCoex, hasFacebookBusiness: value })}
            >
              Possuo uma conta no Facebook Business, ou sou o administrador de uma conta existente
            </CampoCheckbox>
            <div style={{ fontSize: '0.8rem', color: 'var(--tc-color-gray-500)' }}>
              <Botao variant="none-primary" onClick={() => setShowModalCreateFBusiness(true)}>
                <span style={{ fontSize: '0.8rem' }}>
                  Não tenho uma conta no Facebook Business. O que fazer?
                </span>
              </Botao>
            </div>

            <CampoCheckbox
              name='acceptTermsCoex'
              size='large'
              value={checklistCoex.acceptTerms}
              onChange={(value) => setChecklistCoex({ ...checklistCoex, acceptTerms: value })}
            >
              Li e aceito os Termos de Serviço do WhatsApp Business
            </CampoCheckbox>
            <div style={{ fontSize: '0.8rem', color: 'var(--tc-color-gray-500)' }}>
              Leia os Termos de Serviço aqui: <Link href="https://www.whatsapp.com/legal/business-terms" target="_blank">https://www.whatsapp.com/legal/business-terms</Link>
            </div>

            <CampoCheckbox
              name='acceptPrivacyPolicyCoex'
              size='large'
              value={checklistCoex.acceptPrivacyPolicy}
              onChange={(value) => setChecklistCoex({ ...checklistCoex, acceptPrivacyPolicy: value })}
            >
              Li e aceito a Política de Privacidade do WhatsApp Business
            </CampoCheckbox>
            <div style={{ fontSize: '0.8rem', color: 'var(--tc-color-gray-500)' }}>
              Leia a Política de Privacidade aqui: <Link href="https://www.whatsapp.com/legal/privacy-policy" target="_blank">https://www.whatsapp.com/legal/privacy-policy</Link>
            </div>

            <CampoCheckbox
              name='acceptCommercialPoliciesCoex'
              size='large'
              value={checklistCoex.acceptCommercialPolicies}
              onChange={(value) => setChecklistCoex({ ...checklistCoex, acceptCommercialPolicies: value })}
            >
              Declaro que minha empresa está de acordo com as Políticas Comerciais do WhatsApp Business, e que não está nas organizações proibidas ou com restrições de uso
            </CampoCheckbox>
            <div style={{ fontSize: '0.8rem', color: 'var(--tc-color-gray-500)' }}>
              Leia as Políticas Comerciais aqui: <Link href="https://business.whatsapp.com/policy" target="_blank">https://business.whatsapp.com/policy</Link>
            </div>
          </VBox>
        </div>
      </Modal>

      <Modal
        size="md"
        title="Apagar conta do Whatsapp"
        show={showModalWhatsappAccountFaq}
        onClose={() => setShowModalWhatsappAccountFaq(false)}
        onCancel={() => setShowModalWhatsappAccountFaq(false)}
        onConfirm={() => setShowModalWhatsappAccountFaq(false)}
        hideControls
      >
        <VBox gap="16px" style={{ padding: '16px' }}>
          <Descricao>Fique atento:</Descricao>
          <ul>
            <li>
              Apagar a conta do WhatsApp no seu aparelho não remove a conta do Facebook Business associada.
            </li>
            <li>
              A conta do WhatsApp será removida permanentemente e não poderá ser recuperada.
            </li>
            <li>
              <b style={{ color: 'var(--tc-color-danger)' }}>Todos os dados associados à conta, incluindo mensagens, contatos e configurações, serão perdidos.</b>
            </li>
          </ul>
          <Descricao>
            Se isto for um problema, recomendamos que você use outro número de telefone para começar a interagir com seus clientes. Assim você poderá manter
            seu histórico de conversas e contatos no número antigo enquanto redireciona os clientes. Se precisar de ajuda, entre em contato conosco para avaliarmos a melhor solução.
          </Descricao>
          <Descricao>
            Está ciente do que irá acontecer e está tudo bem? Siga os passos <Link href="https://faq.whatsapp.com/2138577903196467/" target="_blank">neste link</Link> para apagar sua conta do WhatsApp.
          </Descricao>
        </VBox>
      </Modal>

      <Modal
        size="md"
        title="Criar conta no Facebook Business"
        show={showModalCreateFBusiness}
        onClose={() => setShowModalCreateFBusiness(false)}
        onCancel={() => setShowModalCreateFBusiness(false)}
        onConfirm={() => setShowModalCreateFBusiness(false)}
        hideControls
      >
        <VBox gap="16px" style={{ padding: '16px' }}>
          <Descricao>
            Para criar uma conta no Facebook Business, siga os passos abaixo:
          </Descricao>
          <ol>
            <li>
              Acesse o <Link href="https://business.facebook.com/" target="_blank">Gerenciador de Negócios do Facebook</Link>.
            </li>
            <li>
              Clique em "Criar conta" e preencha as informações solicitadas.
            </li>
            <li>
              Após criar a conta, crie também uma página para seu negócio.
            </li>
          </ol>
        </VBox>
      </Modal>

      <Modal
        ignoreOverlayClick
        size="lg"
        title={editMode ? 'Editar canal' : 'Novo canal'}
        show={!!editObject}
        onClose={handleCloseModal}
        onCancel={handleCloseModal}
        onConfirm={handleCanalChange}
      >
        <FormCanal
          host={host}
          value={editObject as CanalDto}
          onChange={setEditObject}
          fieldErrors={fieldErrors}
        />
      </Modal>
      <VBox gap="16px" style={{ height: 'calc(100vh - 32px)' }}>
        {/* Header */}
        <Grid>
          <GridItem sm={12} md={6}>
            <VBox>
              <Titulo>Canal</Titulo>
              <Descricao>Detalhes do Canal</Descricao>
            </VBox>
          </GridItem>
          <GridItem sm={12} md={6}>
            <HBox gap="12px" className={styles.headerAcoes}>
              <div>
                <BotaoSeletor
                  variant="primary"
                  options={[
                    {
                      id: 'whatsapp',
                      label: (
                        <HBox>
                          <IconeCanal tipo="whatsapp" style={{ height: '24px' }} />{' '}
                          Adicionar whatsapp
                        </HBox>
                      ),
                    },
                    // Só aparece quando o config_id de coexistência está configurado
                    // nesta instalação (VITE_WHATSAPP_COEX_CONFIG_ID).
                    ...(coexistenciaDisponivel() ? [{
                      id: 'whatsapp-coex',
                      label: (
                        <HBox>
                          <IconeCanal tipo="whatsapp" style={{ height: '24px' }} />{' '}
                          Adicionar whatsapp já em uso no celular
                        </HBox>
                      ),
                    }] : []),
                    {
                      id: 'instagram',
                      label: (
                        <HBox>
                          <IconeCanal tipo="instagram" style={{ height: '24px' }} />{' '}
                          Adicionar Instagram
                        </HBox>
                      ),
                    },
                    {
                      id: 'telegram',
                      label: (
                        <HBox>
                          <IconeCanal tipo="telegram" style={{ height: '24px' }} />{' '}
                          Adicionar telegram
                        </HBox>
                      ),
                    },
                    {
                      id: 'email',
                      label: (
                        <HBox>
                          <IconeCanal tipo="email" style={{ height: '24px' }} />{' '}
                          Adicionar e-mail
                        </HBox>
                      ),
                    },
                    {
                      id: 'voip',
                      label: (
                        <HBox>
                          <IconeCanal tipo="voip" style={{ height: '24px' }} />{' '}
                          Adicionar VoIP
                        </HBox>
                      ),
                    },
                    {
                      id: 'webchat',
                      label: (
                        <HBox>
                          <IconeCanal tipo="webchat" style={{ height: '24px' }} />{' '}
                          Adicionar webchat
                        </HBox>
                      ),
                    },
                  ]}
                  onChange={v => {
                    if (capacidadesQuery.data?.canais?.limitado) {
                      setShowFreeTierModal(true);
                      return;
                    }

                    if (v === 'webchat') {
                      setEditObject({ tipo: 'webchat', chave_api: '' } as CanalDto);
                    } else if (v === 'telegram') {
                      setEditObject({
                        tipo: 'telegram',
                        chave_api: '',
                      } as CanalDto);
                    } else if (v === 'email') {
                      setEditObject({ tipo: 'email', chave_api: '' } as CanalDto);
                    } else if (v === 'voip') {
                      setEditObject({ tipo: 'voip', chave_api: '' } as CanalDto);
                    } else if (v === 'whatsapp') {
                      setChecklist({
                        noWhatsappAccount: false,
                        hasFacebookBusiness: false,
                        acceptTerms: false,
                        acceptPrivacyPolicy: false,
                        acceptCommercialPolicies: false,
                      });
                      setShowModalNewWhatsapp(true);
                    } else if (v === 'whatsapp-coex') {
                      setChecklistCoex({
                        hasBusinessApp: false,
                        appVersion: false,
                        cienteLimitacoes: false,
                        hasFacebookBusiness: false,
                        acceptTerms: false,
                        acceptPrivacyPolicy: false,
                        acceptCommercialPolicies: false,
                      });
                      setShowModalNewWhatsappCoex(true);
                    } else if (v === 'wa360') {
                      setShowModalLogin360(true);
                    } else if (v === 'wa360-new') {
                      setShowModalNew360(true);
                    } else if (v === 'instagram') {
                      openInstagramWindow();
                    }
                  }}
                >
                  Gerenciar&nbsp;canais
                </BotaoSeletor>
                {capacidadesQuery.data?.canais && (
                  <VBox gap="4px" style={{ alignItems: 'flex-end', marginRight: '8px' }}>

                    {capacidadesQuery.data.canais.limitado ? (
                      <div style={{ fontSize: '0.75rem', color: 'var(--tc-color-danger)', textAlign: 'center' }}>
                        Limite atingido
                      </div>
                    ) : (
                      <div style={{
                        textAlign: 'center',
                        fontSize: '0.875rem',
                        color: capacidadesQuery.data.canais.limitado
                          ? 'var(--tc-color-danger)'
                          : 'var(--tc-color-gray-600)'
                      }}>
                        {capacidadesQuery.data.canais.atual}/{Number(capacidadesQuery.data.canais.limite) ?? '∞'} canais
                      </div>
                    )}
                  </VBox>
                )}
              </div>
            </HBox>
          </GridItem>
        </Grid>

        {/* Filtros */}
        <HBox>
          <CampoTexto
            value={search}
            onChange={setSearch}
            prepend={
              <Icon
                path={mdiMagnify}
                size={1}
                color="var(--tc-color-gray-500)"
              />
            }
            placeholder="Pesquisar"
          />
        </HBox>

        {queryList.isFetching && (
          <div>
            Aguarde...{' '}
            <Icon
              path={mdiLoading}
              size={0.8}
              color="var(--tc-color-gray-700)"
              spin
            />
          </div>
        )}
        {!queryList.isFetching && (
          <div>
            Exibindo {queryFlatList?.length ?? '0'} de {total ?? '0'}{' '}
            resultados.
          </div>
        )}

        <DataTable
          isLoading={queryList.isFetching}
          cabecalhos={headers}
          linhas={queryFlatList ?? []}
          hasMoreData={queryList.hasNextPage}
          onLoadMore={async () => queryList.fetchNextPage()}
        />
      </VBox>
      <script async defer crossOrigin="anonymous" src="https://connect.facebook.net/en_US/sdk.js"></script>
    </LayoutUsuario>
  );
};

export default Page;
